﻿import { Component, EventEmitter, OnInit, Output, Input, ViewChild, ElementRef} from "@angular/core";
import {  ActivatedRoute, Router } from "@angular/router";
import { DataService } from "../../services/dataService";
import { CaptchaComponent } from "../../shared/captcha/captcha.component";
import { ValidationMessage } from "../../validation/validationMessage";
import { ValidationMessageType } from "../../validation/validationMessageType";

declare var $: any;

@Component({
    selector: "jax-resetpassword",
    templateUrl: "./resetPassword.component.html",
})
export class ResetPasswordComponent implements OnInit{
    public user: any = {};
    public token: string;
    public validationMessage: ValidationMessage;
    public resetMessage : ValidationMessage;
    public passwordValidationMessage: ValidationMessage;
    public hasSuccess: boolean;
    public hasError: boolean;
    public hasValidToken: boolean;
    public passwordField: string;
    public confirmPassworField: string;
    public currentPassword: string;
    public passwordRuledescription: string;
    public DisplayPassword: boolean;
    
    captchaChallengeSucceded: boolean;
    @ViewChild(CaptchaComponent)
    @ViewChild("passwordRules") passwordRules: ElementRef;

    public IsForceExpiredChangePassword: boolean;
    @Input() IsChangePassword: boolean;
    @Input() IsProfileSetting: boolean;
    @Input() LoginName: boolean;
    @Input() UserId: Number;
    
    public captcha: CaptchaComponent;
    @Output()
    public goToLogin: EventEmitter<any>;
    constructor(private dataService: DataService, private router: Router, private activateRoute: ActivatedRoute) {
    }
    public get password(): string {
        return this.passwordField;
    }

    public set password(value: string) {
        this.passwordField = value;
        this.setMessage("password");
    }

    public get confirmPassword(): string {
        return this.confirmPassworField;
    }

    public  set confirmPassword(value: string) {
        this.confirmPassworField = value;
        this.setMessage("confirmPassword");
    }

    public ngOnInit() {
        this.hasError = true;
        this.DisplayPassword = false;
        if (this.IsChangePassword || this.IsProfileSetting) {
            this.DisplayPassword = true;
            this.hasValidToken = true;
        }
        else {
            this.activateRoute
                .data
                .subscribe((d) => {
                    this.IsChangePassword = d.IsForceExpiredChangePassword;
                    this.IsForceExpiredChangePassword = d.IsForceExpiredChangePassword;

                    this.validationMessage = null;
                    if (this.IsForceExpiredChangePassword) {
                        let msg = new ValidationMessage();
                        msg.message = "Your passsword has expired and must be changed.";
                        msg.messageType = ValidationMessageType.Error;
                        this.validationMessage = msg;
                        this.DisplayPassword = true;
                        this.hasValidToken = true;
                    } else {

                        this.activateRoute
                            .queryParams
                            .subscribe((params) => {
                                this.token = params["id"];

                                if (this.token) {
                                    return this.checkToken(this.token);
                                } else {
                                    this.DisplayPassword = true;
                                    this.hasValidToken = true;
                                }
                            });
                    }

                });

        }

      

      
        this.passwordRuledescription = "<div><div class='tooltip-title'>Password Rules</div><div style='padding: 10px;'>" +
            "<b>Your password</b>" +
            "<br/><br/><ul><li style='line-height: 10px;'>Must be between 8 and 15 characters long.</li>" +
            "<br/><li style='line-height: 10px;'>Must contain letter and numbers</li>" +
            "<br/><li style='line-height: 10px;'>Must not contain any spaces</li>" +
            "<br/><li style='line-height: 10px;'>Must not contain Login name</li>" +
            "<br/><li style='line-height: 10px;'>Must be different from your last 10 passwords</li></div></div>";


        this.passwordRuledescription = "<div><div style='padding: 5px;'>" +
            "<b>Your password</b>" +
            "<br/><br/><ul><li style='line-height: 10px;'>Must be between 8 and 15 characters long.</li>" +
            "<br/><li style='line-height: 10px;'>Must contain letter and numbers</li>" +
            "<br/><li style='line-height: 10px;'>Must not contain any spaces</li>" +
            "<br/><li style='line-height: 10px;'>Must not contain Login name</li>" +
            "<br/><li style='line-height: 10px;'>Must be different from your last 10 passwords</li></div></div>";

        //$('[data-toggle="tooltip"]').attr("title", this.passwordRuledescription);

        //$('[data-toggle="tooltip"]').tooltip();

        //let msg = new ValidationMessage();
        //msg.message = "<b>Your account is not activated until you create a password.</b>";
        //msg.messageType = ValidationMessageType.Error;
        //this.validationMessage = msg;
    }

    //captchaResponse(response) {
    //    this.captchaChallengeSucceded = response;
    //}

    public setMessage(propertyName: string) {
        this.passwordValidationMessage = null;
        if (this.passwordField != this.confirmPassworField && this.passwordField && this.confirmPassworField) {
            let msg = new ValidationMessage();
            msg.message = "Both password must be equal";
            msg.propertyName = propertyName;
            this.passwordValidationMessage = msg;
            this.hasError = true;
        }
        else {
            this.hasError = false;
        }
    }

    public   setPassword() {
        //if (!this.canResetPassword()) {

        //    return;
        //}


        let el: HTMLElement = this.passwordRules.nativeElement as HTMLElement;

        let apiMethod = "";
        let passwordModel: any = {};
        let passwordChangeMessage: string;

        if (this.IsForceExpiredChangePassword || this.IsChangePassword || this.IsProfileSetting) {
            let currentUser = JSON.parse(localStorage.getItem("currentUser"));
            apiMethod = "common/changePassword";
            passwordChangeMessage = "Password changed successfully.";
            passwordModel = {
                NewPassword: this.password,
                ConfirmPassword: this.confirmPassword,
                OldPassword: this.currentPassword,
                LoginName: currentUser.LoginName,
                UserId: currentUser.UserId
            };
        }
        else {
            apiMethod = "common/reset";
            passwordChangeMessage = "Password created successfully.";
            passwordModel = {
                password: this.password,
                ConfirmPassword: this.confirmPassword,
                Token:this.token
            };
        }

        if(this.password && this.password.length>15){
            let msg = new ValidationMessage();
            msg.message = "Password cannot be more than 15 characters.";
            msg.messageType = ValidationMessageType.Error;
            this.validationMessage = msg ;
            //el.click();
            $('#passwordRules').popover('show');
            document.getElementById('passwordRules').scrollIntoView({ behavior: 'smooth' });
            $('#passwordRules').focus();
            return;
        }


      //  this.captchaChallengeSucceded = false;
      
        this.dataService.post(apiMethod, passwordModel)
            .subscribe(( response ) => {
                this.validationMessage = null;

                if (response.Succeeded == "1") {

                    this.hasSuccess = true;
                    let msg = new ValidationMessage();
                    msg.message = passwordChangeMessage;
                    msg.messageType = ValidationMessageType.Ok;
                    this.validationMessage = msg;
                    this.password = "";
                    this.confirmPassword = "";
                    this.currentPassword = "";
                }
                else if (response.Succeeded == "2") {
                    this.hasSuccess = false;
                    //  this.captcha.reset();
                    let msg = new ValidationMessage();
                    msg.message = response.Message;
                    msg.messageType = ValidationMessageType.Error;
                    this.validationMessage = msg;
                }
                else {
                    this.hasSuccess = false;
                  //  this.captcha.reset();
                    let msg = new ValidationMessage();
                    msg.message = response.Message;
                    msg.messageType = ValidationMessageType.Error;
                    this.validationMessage = msg ;
                    //el.click();
                    $('#passwordRules').popover('show');
                    document.getElementById('passwordRules').scrollIntoView({ behavior: 'smooth' });
                    $('#passwordRules').focus();

                    //$('#pwd').tooltip('show');
                    //document.getElementById('pwd').scrollIntoView({ behavior: 'smooth' })

                }
            },
            (error) => {
                let msg = new ValidationMessage();
               // this.hasValidToken = false;
                msg.messageType = ValidationMessageType.Error;
                if (error && error.error) {
                    msg.message = error.error.Message;
                    this.hasValidToken = true;
                    $('#passwordRules').popover('show');
                    document.getElementById('passwordRules').scrollIntoView({ behavior: 'smooth' })
                    $('#passwordRules').focus();
                } else {
                    msg.message = "Invalid Token";
                    this.hasValidToken = false;
                }
                this.validationMessage = msg;
                return false;
            });
    }

    public  canEnableResetButton() {
        if (this.hasError)
            return false;
        else {
            return this.password &&
                this.confirmPassword &&
                this.password == this.confirmPassword && this.password.length >= 8 && this.confirmPassword.length >= 8;
        }
    }

    public   canResetPassword() {
        var isValid = this.password &&
            this.confirmPassword &&
            this.password == this.confirmPassword && this.password.length >= 8 && this.confirmPassword.length >= 8;
        if (!isValid) {
            let el: HTMLElement = this.passwordRules.nativeElement as HTMLElement;
            el.click();
        }
        return isValid;
        //this.captchaChallengeSucceded;
    }

    private checkToken(token:string): boolean {
        let msg = new ValidationMessage();
        this.dataService.post("common/newusertokenverfication?", JSON.stringify(token))
            .subscribe((resp) => {
                if (resp.Succeeded == "1") {
                    this.hasValidToken = true;
                    this.user.userName = "test";
                    return true;
                }
                else
                {
                    msg.messageType = ValidationMessageType.Error;
                    this.hasValidToken = false;
                    msg.message = resp.Message;
                    this.validationMessage = msg;
                    this.DisplayPassword = false;
                    return false;
                }
            },
            (error) => {
                this.hasValidToken = false;
                msg.messageType = ValidationMessageType.Error;
                if (error && error._body) {
                    msg.message = error.message.Message;
                } else {
                    msg.message = "Invalid Token";
                }
                this.validationMessage = msg;
                this.DisplayPassword = false;
                return false;
            }); 


        return false;
    }

    public  login() {
        this.router.navigate(["/login"], { relativeTo: this.activateRoute, queryParams: { IsLoginSelected:true  }, skipLocationChange: true });
    }

    public showPasswordRule() {
        $('#pwd').tooltip('show');
        document.getElementById('pwd').scrollIntoView({ behavior: 'smooth' });
    }
}
